// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"coursePageBodyStyles_bodyWrapper__Y1M9N"};